import {User} from '@/domain/entities/User';
import {Parcel} from '@/domain/entities/Parcel';
import {Project} from '@/domain/entities/Project';
import {capitalizeString} from '@/utils';
import * as turf from '@turf/turf';

type Props = {
  selectedParcelUuid: string,
  selectedProjectUuid?: string,
  parcels: Array<Parcel>,
  users?: Array<User>,
  projects?: Array<Project>
}

export const getParcelSummary = ({selectedParcelUuid, selectedProjectUuid, parcels, users, projects}: Props) => {

  const selectedParcel = parcels
    .find(p => p.uuid === selectedParcelUuid);

  if(!selectedParcel) return;

  const {uuid, polygon, parcel, subparcel, city, distance, ownerId, geom} = selectedParcel;

  const parcelOwner = users
    ? users.find(o => o.id === ownerId)
    : undefined;

  const projectZone = projects
    ? projects.find(p => p.uuid === selectedProjectUuid)?.zone
    : undefined;

  return {
    uuid,
    polygon,
    parcel,
    subparcel,
    city,
    distance,
    ownerName: parcelOwner ? `${parcelOwner.first_name} ${parcelOwner.last_name}` : '-',
    ownerEmail: parcelOwner?.email ?? '-',
    projectZone: capitalizeString(projectZone),
    geom,
    area: turf.area(geom)
  };

};